<svg width="48"
     height="48"
     viewBox="0 0 48 48"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
      <path d="M16 21V34H21.6667V24.8235H27.3333V34H33V21"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round" />
      <path d="M12 24L24.6984 13L37 24"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round" />
</svg>